// Mobile nav — hamburger toggle + accordion children
const hamburger = document.querySelector('.site-header-hamburger');
const mobileNav = document.getElementById('mobile-nav');

if (hamburger && mobileNav) {

    // Hamburger open/close
    hamburger.addEventListener('click', () => {
        const isOpen = hamburger.getAttribute('aria-expanded') === 'true';
        hamburger.setAttribute('aria-expanded', String(!isOpen));
        mobileNav.classList.toggle('is-open', !isOpen);
        mobileNav.setAttribute('aria-hidden', String(isOpen));
        document.body.classList.toggle('mobile-nav-open', !isOpen);
    });

    // Close on Escape
    document.addEventListener('keydown', e => {
        if (e.key === 'Escape' && mobileNav.classList.contains('is-open')) {
            hamburger.setAttribute('aria-expanded', 'false');
            mobileNav.classList.remove('is-open');
            mobileNav.setAttribute('aria-hidden', 'true');
            document.body.classList.remove('mobile-nav-open');
        }
    });

    // Accordion toggles
    mobileNav.querySelectorAll('.mobile-nav-toggle').forEach(toggle => {
        toggle.addEventListener('click', () => {
            const isOpen = toggle.getAttribute('aria-expanded') === 'true';
            const children = toggle.nextElementSibling;

            toggle.setAttribute('aria-expanded', String(!isOpen));

            if (children) {
                if (isOpen) {
                    children.hidden = true;
                } else {
                    children.hidden = false;
                }
            }
        });
    });

}
